module.exports = __webpack_public_path__ + "static/hewards_handy_haversack-f1b157444d6e90a853261d4fce661aa5.jpeg";